import { Extension } from '@tiptap/core';
import { embedSuggestionExtension } from './embedSuggestion';
import { embedExtension as embedExtensionBase } from './shared/embed';

import codepen from './integrations/codepen';
import dbDiagram from './integrations/dbDiagram';
import descript from './integrations/descript';
import diagrams from './integrations/diagrams';
import figma from './integrations/figma';
import gist from './integrations/gist';
import gliffy from './integrations/gliffy';
import googleCalendar from './integrations/googleCalendar';
import googleDataStudio from './integrations/googleDataStudio';
import googleDocs from './integrations/googleDocs';
import googleDrawings from './integrations/googleDrawings';
import googleDrive from './integrations/googleDrive';
import googleSheets from './integrations/googleSheets';
import googleSlides from './integrations/googleSlides';
import linkMetadata from './integrations/link';
import loom from './integrations/loom';
import lucidchart from './integrations/lucidchart';
import marvel from './integrations/marvel';
import mindmeister from './integrations/mindmeister';
import miro from './integrations/miro';
import prezi from './integrations/prezi';
import spotify from './integrations/spotify';
import tldraw from './integrations/tldraw';
import trello from './integrations/trello';
import typeform from './integrations/typeform';
import vimeo from './integrations/vimeo';
import whimsical from './integrations/whimsical';
import youtube from './integrations/youtube';

export const embedExtension = Extension.create({
  name: 'embedExtension',
  addExtensions() {
    return [
      embedExtensionBase,
      embedSuggestionExtension,
      linkMetadata,
      youtube,
      gist,
      googleDocs,
      figma,
      googleDrive,
      codepen,
      dbDiagram,
      spotify,
      googleCalendar,
      descript,
      diagrams,
      gliffy,
      googleDataStudio,
      googleDrawings,
      googleSheets,
      googleSlides,
      loom,
      lucidchart,
      marvel,
      mindmeister,
      miro,
      prezi,
      tldraw,
      trello,
      typeform,
      vimeo,
      whimsical,
    ];
  },
});
